import { render } from "./CameraManagement.vue?vue&type=template&id=1a6e9fb8"
import script from "./CameraManagement.vue?vue&type=script&lang=js"
export * from "./CameraManagement.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__